import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function PoliticasPrivacidadePage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // SEO Meta tags
  useEffect(() => {
    document.title = 'Políticas de Privacidade - FF Travel Angola | Proteção de Dados';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Políticas de privacidade da FF Travel Angola. Como recolhemos, utilizamos e protegemos os seus dados pessoais em conformidade com a legislação angolana de proteção de dados.');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'políticas privacidade FF Travel, proteção dados Angola, RGPD Angola, privacidade agência viagens, segurança dados pessoais');
    }

    // Open Graph
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', 'Políticas de Privacidade - FF Travel Angola');

    let ogDescription = document.querySelector('meta[property="og:description"]');
    if (!ogDescription) {
      ogDescription = document.createElement('meta');
      ogDescription.setAttribute('property', 'og:description');
      document.head.appendChild(ogDescription);
    }
    ogDescription.setAttribute('content', 'Como protegemos os seus dados pessoais. Políticas de privacidade em conformidade com a legislação angolana.');

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', window.location.href);

    // JSON-LD Schema
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "WebPage",
      "name": "Políticas de Privacidade",
      "description": "Políticas de privacidade da FF Travel Angola sobre proteção de dados pessoais",
      "url": window.location.href,
      "inLanguage": "pt-AO",
      "isPartOf": {
        "@type": "WebSite",
        "name": "FF Travel Angola",
        "url": window.location.origin
      },
      "about": {
        "@type": "TravelAgency",
        "name": "FF Prestação & Serviço, Lda",
        "legalName": "FF Prestação & Serviço, Lda",
        "taxID": "500714988"
      }
    });
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  return (
    <>
      <div className="min-h-screen bg-white">
      {/* Navegação */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
      }`}>
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center">
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/821bfe14b1fc609bf2a57dd541a10a42.png" 
                alt="Logótipo FF Travel Angola - Agência de Viagens em Luanda" 
                className="h-24 md:h-28"
              />
            </Link>
            
            <div className="hidden md:flex items-center space-x-8">
              <Link to="/" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Início
              </Link>
              <Link to="/agencia-viagens" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Agência de Viagens
              </Link>
              <Link to="/loja-servicos" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Loja & Serviços
              </Link>
              <Link to="/sobre" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Sobre
              </Link>
              <Link to="/contactos" className="text-[#1e40af] hover:text-[#ff6b35] transition-colors font-medium">
                Contactos
              </Link>
            </div>

            <a 
              href="https://wa.me/244936769113" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hidden md:block bg-[#ff6b35] text-white px-6 py-3 rounded-full font-medium hover:bg-[#ff5722] transition-all shadow-md whitespace-nowrap cursor-pointer"
            >
              Pedir Cotação
            </a>
          </div>
        </div>
      </nav>

      {/* Hero */}
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse"></div>
          <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#ff6b35] rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
        </div>
        <div className="max-w-7xl mx-auto px-6 relative z-10">
          <div className="text-center text-white animate-fade-in">
            <div className="inline-flex items-center gap-2 bg-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-6 animate-slide-up">
              <i className="ri-shield-check-line text-xl"></i>
              <span className="text-sm font-medium">Proteção de Dados</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6 animate-slide-up" style={{ animationDelay: '0.1s' }}>
              Políticas de Privacidade
            </h1>
            <p className="text-xl text-white/90 max-w-3xl mx-auto animate-slide-up" style={{ animationDelay: '0.2s' }}>
              Última atualização: Janeiro de 2025
            </p>
          </div>
        </div>
      </section>

      {/* Conteúdo */}
      <section className="py-24 bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            
            {/* Introdução */}
            <div className="mb-12">
              <p className="text-gray-700 leading-relaxed text-lg">
                A <strong>FF Prestação & Serviço, Lda</strong> (FF TRAVEL), com NIF 500714988, está comprometida em proteger a privacidade e os dados pessoais dos seus clientes. Esta Política de Privacidade descreve como recolhemos, utilizamos, armazenamos e protegemos as suas informações pessoais.
              </p>
            </div>

            {/* 1. Informações que Recolhemos */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-file-list-3-line text-[#ff6b35]"></i>
                1. Informações que Recolhemos
              </h2>
              <div className="bg-gray-50 rounded-xl p-8">
                <p className="text-gray-700 mb-4"><strong>Recolhemos as seguintes informações:</strong></p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Dados de Identificação:</strong> Nome completo, idade, número de identificação</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Dados de Contacto:</strong> Email, telefone, endereço</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Dados de Viagem:</strong> Destinos, datas, preferências de viagem</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Dados de Pagamento:</strong> Informações necessárias para processar transações</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Documentos:</strong> Passaportes, vistos e outros documentos de viagem</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 2. Como Utilizamos as Suas Informações */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-settings-3-line text-[#ff6b35]"></i>
                2. Como Utilizamos as Suas Informações
              </h2>
              <div className="bg-gray-50 rounded-xl p-8">
                <p className="text-gray-700 mb-4"><strong>Utilizamos os seus dados para:</strong></p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span>Processar reservas de passagens aéreas, hotéis e pacotes turísticos</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span>Tratar pedidos de vistos e documentação de viagem</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span>Comunicar sobre o estado das suas reservas e serviços</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span>Fornecer suporte ao cliente e atendimento personalizado</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span>Enviar informações sobre promoções e ofertas (com o seu consentimento)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-arrow-right-circle-fill text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span>Cumprir obrigações legais e regulamentares</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 3. Partilha de Informações */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-share-line text-[#ff6b35]"></i>
                3. Partilha de Informações
              </h2>
              <div className="bg-gray-50 rounded-xl p-8">
                <p className="text-gray-700 mb-4">
                  <strong>Podemos partilhar os seus dados com:</strong>
                </p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-building-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Companhias Aéreas e Hotéis:</strong> Para processar as suas reservas</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-government-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Autoridades Consulares:</strong> Para processar vistos e documentação</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-bank-card-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Processadores de Pagamento:</strong> Para transações financeiras seguras</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-shield-check-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Seguradoras:</strong> Para contratação de seguros de viagem</span>
                  </li>
                </ul>
                <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                  <p className="text-sm text-blue-800">
                    <strong>Nota:</strong> Nunca vendemos os seus dados pessoais a terceiros para fins de marketing.
                  </p>
                </div>
              </div>
            </div>

            {/* 4. Segurança dos Dados */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-lock-line text-[#ff6b35]"></i>
                4. Segurança dos Dados
              </h2>
              <div className="bg-gray-50 rounded-xl p-8">
                <p className="text-gray-700 mb-4">
                  Implementamos medidas de segurança técnicas e organizacionais para proteger os seus dados pessoais contra acesso não autorizado, perda, destruição ou alteração.
                </p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-shield-check-fill text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span>Encriptação de dados sensíveis</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-shield-check-fill text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span>Acesso restrito aos dados apenas a funcionários autorizados</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-shield-check-fill text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span>Sistemas de backup regulares</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-shield-check-fill text-green-600 text-xl flex-shrink-0 mt-1"></i>
                    <span>Monitorização contínua de segurança</span>
                  </li>
                </ul>
              </div>
            </div>

            {/* 5. Os Seus Direitos */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-user-settings-line text-[#ff6b35]"></i>
                5. Os Seus Direitos
              </h2>
              <div className="bg-gray-50 rounded-xl p-8">
                <p className="text-gray-700 mb-4"><strong>Tem o direito de:</strong></p>
                <ul className="space-y-3 text-gray-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-eye-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Acesso:</strong> Solicitar uma cópia dos seus dados pessoais</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-edit-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Retificação:</strong> Corrigir dados incorretos ou incompletos</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-delete-bin-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Eliminação:</strong> Solicitar a eliminação dos seus dados (sujeito a obrigações legais)</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-forbid-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Oposição:</strong> Opor-se ao processamento dos seus dados para fins de marketing</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-download-line text-[#1e40af] text-xl flex-shrink-0 mt-1"></i>
                    <span><strong>Portabilidade:</strong> Receber os seus dados num formato estruturado</span>
                  </li>
                </ul>
                <div className="mt-6 p-4 bg-teal-50 border border-teal-200 rounded-lg">
                  <p className="text-sm text-teal-800">
                    <strong>Para exercer os seus direitos, contacte-nos:</strong><br />
                    Email: info@fftravel.ao (exemplo)<br />
                    Telefone: +244 936 769 113<br />
                    WhatsApp: +244 936 769 113
                  </p>
                </div>
              </div>
            </div>

            {/* 6. Retenção de Dados */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-time-line text-[#ff6b35]"></i>
                6. Retenção de Dados
              </h2>
              <div className="bg-gray-50 rounded-xl p-8">
                <p className="text-gray-700">
                  Mantemos os seus dados pessoais apenas pelo tempo necessário para cumprir as finalidades para as quais foram recolhidos, incluindo requisitos legais, contabilísticos ou de relatório. Os dados de viagem são mantidos por um período mínimo de 5 anos conforme exigido pela legislação angolana.
                </p>
              </div>
            </div>

            {/* 7. Cookies e Tecnologias Similares */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-cookie-line text-[#ff6b35]"></i>
                7. Cookies e Tecnologias Similares
              </h2>
              <div className="bg-gray-50 rounded-xl p-8">
                <p className="text-gray-700 mb-4">
                  O nosso website utiliza cookies para melhorar a sua experiência de navegação. Os cookies são pequenos ficheiros de texto armazenados no seu dispositivo que nos ajudam a:
                </p>
                <ul className="space-y-2 text-gray-700">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                    <span>Lembrar as suas preferências</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                    <span>Analisar o tráfego do website</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-line text-[#ff6b35] text-xl flex-shrink-0 mt-1"></i>
                    <span>Melhorar a funcionalidade do site</span>
                  </li>
                </ul>
                <p className="text-gray-700 mt-4">
                  Pode configurar o seu navegador para recusar cookies, mas isso pode afetar a funcionalidade do website.
                </p>
              </div>
            </div>

            {/* 8. Alterações à Política */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-refresh-line text-[#ff6b35]"></i>
                8. Alterações à Política de Privacidade
              </h2>
              <div className="bg-gray-50 rounded-xl p-8">
                <p className="text-gray-700">
                  Reservamo-nos o direito de atualizar esta Política de Privacidade periodicamente. Quaisquer alterações serão publicadas nesta página com a data de atualização. Recomendamos que reveja esta política regularmente para se manter informado sobre como protegemos os seus dados.
                </p>
              </div>
            </div>

            {/* 9. Contacto */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-[#1e3a8a] mb-6 flex items-center gap-3">
                <i className="ri-mail-line text-[#ff6b35]"></i>
                9. Contacto
              </h2>
              <div className="bg-gradient-to-br from-[#1e40af] to-[#1e3a8a] rounded-xl p-8 text-white">
                <p className="mb-6 text-lg">
                  Se tiver questões sobre esta Política de Privacidade ou sobre como tratamos os seus dados pessoais, contacte-nos:
                </p>
                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <i className="ri-building-line text-2xl text-[#ff6b35]"></i>
                    <div>
                      <p className="font-semibold">FF Prestação & Serviço, Lda</p>
                      <p className="text-white/80 text-sm">NIF: 500714988</p>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-map-pin-line text-2xl text-[#ff6b35]"></i>
                    <p>Rua do Campo do Escoqueiro, de frente ao prédio do Cucu, Luanda, Angola</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-phone-line text-2xl text-[#ff6b35]"></i>
                    <div>
                      <a href="tel:+244936769113" className="hover:text-[#ff6b35] transition-colors cursor-pointer">+244 936 769 113</a>
                      <span className="mx-2">|</span>
                      <a href="tel:+244927606910" className="hover:text-[#ff6b35] transition-colors cursor-pointer">+244 927 606 910</a>
                    </div>
                  </div>
                  <div className="flex items-center gap-3">
                    <i className="ri-whatsapp-line text-2xl text-[#ff6b35]"></i>
                    <a 
                      href="https://wa.me/244936769113" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="hover:text-[#ff6b35] transition-colors cursor-pointer"
                    >
                      WhatsApp: +244 936 769 113
                    </a>
                  </div>
                </div>
              </div>
            </div>

            {/* Consentimento */}
            <div className="bg-teal-50 border-l-4 border-teal-600 rounded-lg p-8">
              <div className="flex items-start gap-4">
                <i className="ri-information-line text-3xl text-teal-600 flex-shrink-0"></i>
                <div>
                  <h3 className="text-xl font-bold text-teal-900 mb-3">Consentimento</h3>
                  <p className="text-teal-800 leading-relaxed">
                    Ao utilizar os nossos serviços e fornecer os seus dados pessoais, você consente com a recolha, utilização e partilha das suas informações conforme descrito nesta Política de Privacidade.
                  </p>
                </div>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl font-bold text-[#1e3a8a] mb-6">
            Tem Dúvidas sobre Privacidade?
          </h2>
          <p className="text-xl text-gray-600 mb-10">
            A nossa equipa está disponível para esclarecer qualquer questão
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a 
              href="https://wa.me/244936769113" 
              target="_blank" 
              rel="noopener noreferrer"
              className="inline-block bg-[#ff6b35] text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-[#ff5722] transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Falar no WhatsApp
            </a>
            <Link 
              to="/contactos"
              className="inline-block bg-[#1e40af] text-white px-10 py-5 rounded-full font-bold text-lg hover:bg-[#1e3a8a] transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              Ver Contactos
            </Link>
          </div>
        </div>
      </section>

      {/* Rodapé */}
      <footer className="bg-black text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/3c15764482320d2816a8cc3fe11ecba0/e349152b587c7809cba7381685cd68b4.png" 
                alt="Logótipo FF Travel Angola branco - Agência de Viagens" 
                className="h-24 md:h-28 mb-8"
              />
              <p className="text-white/70 leading-relaxed mb-4">
                FF Prestação & Serviço, Lda
              </p>
              <p className="text-white/50 text-sm">
                NIF: 500714988
              </p>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Contactos</p>
              <div className="space-y-3">
                <a href="tel:+244936769113" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                  +244 936 769 113
                </a>
                <a href="tel:+244927606910" className="block text-white hover:text-[#ff6b35] transition-colors cursor-pointer">
                  +244 927 606 910
                </a>
              </div>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Localização</p>
              <p className="text-white/70 leading-relaxed">
                Rua do Campo do Escoqueiro<br />
                De frente ao prédio do Cucu<br />
                Luanda, Angola
              </p>
            </div>

            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider mb-4">Links Rápidos</p>
              <div className="space-y-3">
                <Link to="/" className="block text-white hover:text-[#ff6b35] transition-colors">Início</Link>
                <Link to="/agencia-viagens" className="block text-white hover:text-[#ff6b35] transition-colors">Agência de Viagens</Link>
                <Link to="/loja-servicos" className="block text-white hover:text-[#ff6b35] transition-colors">Loja & Serviços</Link>
                <Link to="/sobre" className="block text-white hover:text-[#ff6b35] transition-colors">Sobre</Link>
                <Link to="/politicas-privacidade" className="block text-white hover:text-[#ff6b35] transition-colors">Políticas de Privacidade</Link>
              </div>
            </div>
          </div>

          <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/50 text-sm">
              © 2025 FF TRAVEL. Todos os direitos reservados.
            </p>
            <div className="flex items-center gap-4">
              <Link to="/politicas-privacidade" className="text-white/50 hover:text-white transition-colors text-sm">
                Políticas de Privacidade
              </Link>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/50 hover:text-white transition-colors cursor-pointer text-sm">Web Design</a>
            </div>
          </div>
        </div>
      </footer>

      {/* Botão WhatsApp Flutuante */}
      <a 
        href="https://wa.me/244936769113" 
        target="_blank" 
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 w-16 h-16 bg-[#ff6b35] rounded-full flex items-center justify-center text-white shadow-2xl hover:scale-110 transition-transform z-50 animate-pulse cursor-pointer"
        style={{ boxShadow: '0 8px 24px rgba(255, 107, 53, 0.4)' }}
      >
        <i className="ri-whatsapp-line text-3xl"></i>
      </a>
    </div>
    </>
  );
}
